module.exports = __webpack_public_path__ + "img/icon-warning-icing-yellow.abbe8140.svg";